import React from 'react'
import { Popover, XStack } from '@my/ui'
import { Reaction, ReactionType } from 'app/types'
import { ReactionItem } from './reaction-item'

export interface ReactionItem {
  name: string
  type: ReactionType
  Icon: string
}

export const ReactionList: ReactionItem[] = [
  {
    name: 'Like',
    type: 'like',
    Icon: '👍',
  },
  {
    name: 'Happy',
    type: 'haha',
    Icon: '😂',
  },
  {
    name: 'Love',
    type: 'love',
    Icon: '❤️',
  },
  {
    name: 'Sad',
    type: 'sad',
    Icon: '😢',
  },
  {
    name: 'Angry',
    type: 'angry',
    Icon: '😡',
  },
]

export interface ReactionPopupProps {
  activeReaction?: Reaction | undefined
  open?: boolean
  trigger: React.ReactNode
  onReact: (type: ReactionType) => void
  onOpenChange: (open: boolean) => void
}

export const ReactionPopup = ({
  activeReaction,
  open,
  trigger,
  onReact,
  onOpenChange,
}: ReactionPopupProps) => {
  return (
    <Popover
      open={open}
      onOpenChange={onOpenChange}
      placement="top-end"
      adaptProps={{
        platform: 'native',
      }}
      sheetProps={{
        snapPoints: [20],
      }}
      contentProps={{
        br: "$10"
      }}
      anchor={trigger}
    >
      <XStack br="$5" gap="$2" justifyContent="space-between" mx="auto" p="$2">
        {ReactionList.map((reaction, index) => (
          <ReactionItem
            key={index}
            Icon={reaction.Icon}
            onPress={() => onReact(reaction.type)}
            name={reaction.name}
            isActive={reaction.type === activeReaction?.name}
          />
        ))}
      </XStack>
    </Popover>
  )
}
